export const getShowPasswordIconClass = (showPassword, hasErrors) => {
    const obscurePasswordClass = showPassword ? 'icon-pass-off show-password-off' : 'icon-pass-on show-password';

    return `icons icons--${obscurePasswordClass} ${(hasErrors && 'no-valid') || 'valid'}`;
};
